import { useCallback, useEffect, useRef, useState } from "react";
import { getExpertiseCounters } from "../../services/partnerExpertService";
import { ExpertiseCounterModel } from "./models/ExpertiseCounterModel";

export const useExpertiseCounters = (partnerId: number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [counters, setCounters] = useState<ExpertiseCounterModel>({
        accepted: 0,
        totalRequests: 0,
        declined: 0,
        closedExpertise: 0,
        openExpertise: 0,
        pending: 0,
        rating: null,
        unanswered: 0
    });

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            const _result = await getExpertiseCounters(partnerId)
            if(!isMountedRef.current)
                return;
            setCounters(_result);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [partnerId]);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, counters }
}